<template>
    <!--    v-if="isOverflow" -->
    <el-tooltip
   
      effect="dark"
      placement="bottom"
      :content="content"
      popper-class="ellipsis_tooltip_css"
      :open-delay="500"
      :disabled="!isOverflow"
    >
      <span ref="text" class="ellipsis">
       {{ content }}
      </span>
    </el-tooltip>
  
    <!-- <span v-else ref="text" class="ellipsis">
      {{ content }}
    </span> -->
  </template>
    
    <script>
  export default {
    name: "EllipsisTooltip",
    props: {
      content: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        isOverflow: false,
      };
    },
    mounted() {
      this.$nextTick(this.checkOverflow);
    },
    watch: {
      content() {
    
        this.$nextTick(this.checkOverflow);
      },
    },
    methods: {
      checkOverflow() {
        const el = this.$refs.text;
        if (!el) return;
        this.isOverflow = el.scrollWidth > el.clientWidth;
        console.log(this.isOverflow);
      },
    },
  };
  </script>
    
    <style scoped>
  .ellipsis {
    width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
  }
  </style>
  <style>
  .ellipsis_tooltip_css {
    max-width: 300px; /* 你想要的最大宽度 */
    white-space: normal; /* 允许换行 */
    word-break: break-all; /* 长文本强制换行 */
    line-height: 1.6;
    
  }
  </style>
  
    